module.exports = __webpack_public_path__ + "static/media/ELS200FL03.18e43e57.png";